// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1egV0","title":"ClientInsurance_title__ZlCsN","itemText":"ClientInsurance_itemText__2FO4i"};